<template>
  <section class="section content --top --padding-top">
    <div class="text-image-section star-border">
      <div class="text-image-section__image">
        <Image :source="content.image" />
      </div>

      <div class="text-image-section__content">
        <div>
          <h2 v-if="content.title" class="heading --two" v-reveal>{{ content.title }}</h2>

          <p class="text-image-section__description">
            {{ content.description }}
          </p>
        </div>

        <a
          v-if="content.link && content.label"
          :href="content.link"
          class="button"
          target="_blank"
          rel="noopener"
        >
          {{ content.label }}
        </a>
      </div>

      <Icon id="star" class="--star --40 --square-card" />
    </div>
  </section>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'

export default {
  name: 'TextImageSection',

  inject: ['mq'],

  components: {
    Icon,
    Image,
  },

  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
